var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H28C29.1046 0 30 0.895431 30 2V28C30 29.1046 29.1046 30 28 30H2C0.89543 30 0 29.1046 0 28V2Z",
    fill: "#292828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84351 18.5358V20.8929H20.156V9.10718H9.84351V11.4643",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25439 16.7678H10.433",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25439 15H10.433",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25439 13.2319H10.433",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 14.1159C15.6508 14.1159 16.1784 13.5883 16.1784 12.9374C16.1784 12.2865 15.6508 11.7588 14.9999 11.7588C14.349 11.7588 13.8213 12.2865 13.8213 12.9374C13.8213 13.5883 14.349 14.1159 14.9999 14.1159Z",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3571 18.2409C17.3571 16.9391 16.3018 15.8838 15 15.8838C13.6981 15.8838 12.6428 16.9391 12.6428 18.2409",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.d9a1d92e15a80cfe929adf7e9c723dbc.svg";
export { ForwardRef as ReactComponent };